import { combineEpics } from 'redux-observable';
import { of } from 'rxjs';
import * as ReduxObservablesEpicUtils from '@ane/core/lib/utils/ReduxObservablesEpicUtils';
import { dataSourceDetailActionTypes, dataSourceDetailLoadingAction, dataSourceDetailLoadedAction, } from '../ducks/DataSourceOverrideDetail.ducks';
import { getAsyncRequestStatus } from '@ane/core/lib/models';
import DataSourceResource from '../../../DataSource.resource';
const loadDataSourceArgs = {
    filterOnType: dataSourceDetailActionTypes.LOAD,
    loadResource: (payload, state) => {
        return DataSourceResource.getDataSource(payload.workspaceId, payload.dataSourceName);
    },
    loadingAction: dataSourceDetailLoadingAction,
    loadedAction: (successData, payload, error) => {
        const result = {
            status: getAsyncRequestStatus(error || ''),
            data: successData,
            error: error,
        };
        return of(dataSourceDetailLoadedAction(payload, result));
    },
};
export const loadDataSourceOverrideEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(loadDataSourceArgs);
export default combineEpics(loadDataSourceOverrideEpic);

//# sourceMappingURL=DataSourceOverrideDetailEpic.js.map
